import React from "react";
import { Box as MuiBox, Tooltip as MuiTooltip, Typography as MuiTypography } from "@mui/material";
import { useCollabSession } from "./CollabSessionContext";
import { dedupePeersByUser, usePresence } from "./usePresence";

/**
 * Header presence: one colored initial per remote collaborator, plus a
 * "reconnecting" pill while the websocket is down. Renders nothing when
 * collab is inactive.
 */
const CollabAvatarStack: React.FC = () => {
    const session = useCollabSession();
    const peers = dedupePeersByUser(usePresence());

    if (!session) return null;

    return (
        <MuiBox sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {session.status !== "connected" && (
                <MuiTypography
                    component="span"
                    sx={{
                        px: "9px",
                        py: "4px",
                        borderRadius: "999px",
                        bgcolor: "rgba(217, 119, 6, 0.08)",
                        border: "1px solid rgba(217, 119, 6, 0.18)",
                        color: "#d97706",
                        fontSize: 11,
                        fontWeight: 600
                    }}
                >
                    Reconnecting…
                </MuiTypography>
            )}
            <MuiBox sx={{ display: "flex" }}>
                {peers.map((peer, index) => (
                    <MuiTooltip
                        key={peer.user!.userid}
                        title={`${peer.user!.name} is ${peer.activity?.activity ?? "viewing"}`}
                        placement="bottom"
                        arrow
                    >
                        <MuiBox
                            sx={{
                                width: 24,
                                height: 24,
                                borderRadius: "12px",
                                bgcolor: peer.user!.color,
                                border: "2px solid #ffffff",
                                ml: index ? "-8px" : 0,
                                fontSize: 10,
                                fontWeight: 700,
                                color: "#fff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            {peer.user!.name.charAt(0).toUpperCase()}
                        </MuiBox>
                    </MuiTooltip>
                ))}
            </MuiBox>
        </MuiBox>
    );
};

export default CollabAvatarStack;
